'use client';

// NOTE: Next.js App Router requires error.tsx/global-error.tsx to use a
// default export. The "named exports only" project convention does not apply
// to these framework-mandated entry points.

import { useEffect } from 'react';
import { Button } from './ui/button';

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: Props) {
  useEffect(() => {
    console.error('Unhandled error', error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <main className="flex min-h-screen items-center justify-center bg-background p-6">
          <div className="max-w-md space-y-4 text-center">
            <h1 className="text-xl font-semibold">Something went wrong</h1>
            <p className="text-sm text-muted-foreground">
              We hit an unexpected error. Try again, or refresh the page.
            </p>
            {error.digest ? (
              <p className="font-mono text-xs text-muted-foreground">Error ID: {error.digest}</p>
            ) : null}
            <div className="flex justify-center gap-2">
              <Button onClick={reset}>Try again</Button>
              <Button variant="outline" onClick={() => window.location.assign('/')}>
                Go home
              </Button>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
